import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { TransactionLogsComponent } from './transaction-logs.component';

const routes: Routes = [{ path: '', component: TransactionLogsComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class TransactionLogsRoutingModule { }
